import { AnimatePresence, motion } from 'framer-motion'
import { useContext } from 'react'
import { HeaderContext } from '../header/header-provider.client'
import styles from '../../assets/scss/components/cart/cart-drawer.module.scss'
import { MiniCart } from './mini-cart.client'

export const CartDrawer: React.FC = () => {
  const { isCartDrawerOpen, setIsCartDrawerOpen } = useContext(HeaderContext)

  return (
    <>
      <AnimatePresence>
        {isCartDrawerOpen && (
          <motion.div
            animate={{ opacity: 1 }}
            className={styles.overlay}
            exit={{ opacity: 0, transition: { ease: [1, 0, 1, 1] } }}
            id="overlay"
            initial={{ opacity: 0 }}
            onClick={() => setIsCartDrawerOpen(false)}
            transition={{ ease: [0, 0, 0, 1] }}
          />
        )}
      </AnimatePresence>
      <AnimatePresence>
        {isCartDrawerOpen && (
          <motion.div
            animate={{ translateX: 0 }}
            className={styles.cartDrawer}
            exit={{ translateX: '100%', transition: { ease: [1, 0, 1, 1] } }}
            id="cart-drawer"
            initial={{ translateX: '100%' }}
            transition={{ ease: [0, 0, 0, 1] }}>
            <MiniCart />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}
